module.exports = __webpack_public_path__ + "15213ca7.svg";